import { useEffect } from 'react';
import { initMtstat, setUserCommonParams } from '@/utils/mtstat';
import {
  setConfig,
  ENV_ENUM,
} from '@meitu/xdesign-widgets/dist/configProvider';
import { initLocalUid } from '@meitu/xdesign-widgets/dist/utils/uidKit';
import { getAppKey, MODULE_ID, getClientID } from '@/constants';
import { useStoreActions, useStoreState } from '@/store';
import { initEnterprise } from '@/services/enterprise';
import { isMobile } from '@/utils';
import {
  initABTest,
  isOpenDeepSeek,
  isOpenPptCommercialization,
} from '@/utils/abtest';
import { checkIsInSdk } from '@/utils/sdk';
import {
  markRecentFeature,
  RecentFeatureKey,
} from '@meitu/xdesign-widgets/dist/recentFeatures';

const AppLogic = () => {
  const finishWidgetsConfig = useStoreActions(
    (action) => action.finishWidgetsConfig,
  );
  const setIsOpenDeepSeek = useStoreActions(
    (actions) => actions.setIsOpenDeepSeek,
  );
  const setIsOpenPptCommercialization = useStoreActions(
    (actions) => actions.setIsOpenPptCommercialization,
  );

  const finishTrack = useStoreState((state) => state.finishTrack);
  const userInfo = useStoreState((state) => state.userModel.userInfo);
  const finishFetchUserInfo = useStoreState(
    (state) => state.userModel.isRequested,
  );

  const handleInitAbTest = async () => {
    await initABTest();
    if (isMobile()) {
      setIsOpenDeepSeek(true);
      return;
    }
    if (checkIsInSdk()) {
      setIsOpenDeepSeek(false);
    } else {
      isOpenDeepSeek().then((isOpen) => {
        setIsOpenDeepSeek(isOpen);
      });
    }
    isOpenPptCommercialization().then((isOpen) => {
      setIsOpenPptCommercialization(isOpen);
    });
  };

  useEffect(() => {
    // xdesign-widgets组件公共参数
    setConfig('client_id', getClientID());
    setConfig('env', process.env.NEXT_PUBLIC_ENV as ENV_ENUM);
    setConfig('app_key', getAppKey());
    setConfig('module_id', MODULE_ID);
    setConfig('theme', 'light');
    setConfig('isTeam', true);
    finishWidgetsConfig();

    // 依赖上面env的设置
    initLocalUid();

    const initFn = async () => {
      // 定制企业版逻辑
      await initEnterprise();
      const is = await import('@meitu/is');
      if (is.isMobile && (is.isXiuXiu || is.isPoster) && is.isIOS) {
        window.addEventListener('WebviewJsBridgeReady', () => {
          console.log('【WebviewJsBridgeReady】');
          // 初始化埋点SDK逻辑
          initMtstat(handleInitAbTest);
        });
      } else {
        // 初始化埋点SDK逻辑
        initMtstat(handleInitAbTest);
      }
    };

    initFn();
    markRecentFeature(RecentFeatureKey.LivePPT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //埋点初始化完成并且用户信息请求完成
  useEffect(() => {
    console.log(
      'finishTrack===',
      finishTrack,
      finishFetchUserInfo,
      window.mtstat,
    );
    if (finishTrack && finishFetchUserInfo) {
      setUserCommonParams({
        isVip: userInfo?.is_vip,
        availableAmount: userInfo?.available_amount,
      });
    }
  }, [
    finishTrack,
    finishFetchUserInfo,
    userInfo?.available_amount,
    userInfo?.is_vip,
  ]);

  useEffect(() => {
    if (userInfo) {
      setConfig('userInfo', userInfo);
    }
  }, [userInfo]);

  return null;
};

export default AppLogic;
